import React, { FC }              from 'react';
import { formatOption }           from '../../../../util';
import { PROJECT_ROLES }          from '../../../../constants/ProductEnums';
import { PROJECT_ROLE_INFO }      from '../../../../constants/ProductEnums';
import { SelectField }            from '../../../components/forms';
import { PreSelectedSelectField } from '../../../../types';
import { LangService }            from '../../../../services';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( PROJECT_ROLES.ADMIN, LangService.getTermFromDictionary( PROJECT_ROLE_INFO.ADMIN.LABEL ) ),
		formatOption( PROJECT_ROLES.MEMBER, LangService.getTermFromDictionary( PROJECT_ROLE_INFO.MEMBER.LABEL ) ),
		formatOption( PROJECT_ROLES.VIEWER, LangService.getTermFromDictionary( PROJECT_ROLE_INFO.VIEWER.LABEL ) ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = {};

export { Dropdown as ProjectRoleDropdown }
